module.exports = __webpack_public_path__ + "static/img/success-bg-small.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/success-bg-small.png
// module id = 589
// module chunks = 0